import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../core/utils/hook';
import EiTestHistoryByStudentScreen from './EiTestHistoryByStudentScreen';

const EiStudentDetailScreen = observer(props => {

    // params
    const { id } = useParams();

    // store
    const { groupAdminStore: { getStudentDetail } } = useStore();

    // lifecycle
    useEffect(() => {
        getStudentDetail(id);
    }, [])

    return (
        <div id='main' className='wrapper main-student-list main-view-student-detail'>
            <section className='content-student-list'>
                <div className='container'>
                    <h1 className='title-primary'>受講者リスト</h1>
                    <div className='title-title'>
                        <h2 className='title-2'>受検履歴EI</h2>
                    </div>
                    <EiTestHistoryByStudentScreen />
                </div>
            </section>
        </div>

    )
})

export default EiStudentDetailScreen;